/**
 * @fileoverview Pure helpers for TodayViewContent layout and focus handlers.
 */

/**
 * @param {string[] | null | undefined} projectFilter
 * @param {string[] | null | undefined} contextFilter
 */
export function hasActiveTaskFilter(projectFilter, contextFilter) {
  return (
    (projectFilter?.length || 0) > 0 || (contextFilter?.length || 0) > 0
  );
}

/**
 * @param {{
 *   user: { uid: string } | null | undefined,
 *   heroTask: import('@/types').Task,
 *   activeFocusTaskId: string | null | undefined,
 *   focusStartTime: number | null | undefined,
 *   stopFocus: () => void,
 *   handleToggleComplete: Function,
 *   handleStartFocus: Function,
 * }} args
 */
export function buildFocusHeroHandlers({
  user,
  heroTask,
  activeFocusTaskId,
  focusStartTime,
  stopFocus,
  handleToggleComplete,
  handleStartFocus,
}) {
  return {
    onToggleComplete: (checked) => {
      if (!user) return;
      handleToggleComplete(heroTask, checked, {
        activeFocusTaskId,
        focusStartTime,
        stopFocus,
      });
    },
    onStartFocus: () => {
      if (!user) return;
      handleStartFocus(heroTask.id, user.uid);
    },
    onStopFocus: stopFocus,
  };
}
